import { useEffect, useState } from 'react';

const useIsMobile = (): boolean => {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect((): (() => void) => {
    const handleWindowSizeChange = (): void => {
      setWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleWindowSizeChange);
    return (): void => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);

  return width <= 768;
};

export default useIsMobile;
